module.exports = __webpack_public_path__ + "img/slider-1-person-1.0a837c56.png";